import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import type { AiSearchPlan, ItemListItem } from '@/types';
import { ItemCard } from './ItemCard';

interface ItemMasonryGridProps {
  items: ItemListItem[];
  onItemClick: (item: ItemListItem) => void;
  aiSearchPlan?: AiSearchPlan | null;
  aiSearchQuery?: string;
}

const HOME_MASONRY_COLUMN_BREAKPOINTS = {
  350: 1,
  640: 2,
  1024: 3,
} as const;

export function ItemMasonryGrid({ items, onItemClick, aiSearchPlan, aiSearchQuery }: ItemMasonryGridProps) {
  return (
    <div data-ai-id="item-masonry-grid">
      <ResponsiveMasonry columnsCountBreakPoints={HOME_MASONRY_COLUMN_BREAKPOINTS}>
        <Masonry gutter="1.25rem">
          {items.map((item) => (
            <div key={item.id} className="w-full" data-ai-id="item-masonry-grid-item">
              <ItemCard
                item={item}
                onClick={() => onItemClick(item)}
                previewMode="intrinsic"
                aiSearchPlan={aiSearchPlan}
                aiSearchQuery={aiSearchQuery}
              />
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </div>
  );
}
